// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salary-form-container {
  max-width: 1000px;
  margin: auto;
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: sans-serif;
}
.salary-component-list-container {
  width: 100%;
  height: 77vh;
  /* overflow: scroll; */
  border: 1px solid black;
  padding: 10px;
}
.salary-component-list-container::-webkit-scrollbar {
  display: none;
}

.salary_form_section {
  border: 1px solid rgb(208, 204, 204);
  border-radius: 8px;
  height: 59vh;
  overflow: scroll;
  padding: 10px;
}
.salary-form {
  display: flex;
  gap: 40px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.form-column {
  flex: 1 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

label {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

label span {
  color: red;
}

input[type="text"],
input[type="date"],
select {
  padding: 8px;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.checkbox-row,
.radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-footer {
  margin-top: 30px;
  text-align: right;
}

.close-button {
  padding: 10px 20px;
  background-color: #28a745; /* green */
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.list_salary_header {
  margin-bottom: 20px;
  margin-left: 10px;
}
.add-button-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.add-button-container h3{
margin: auto;
}

.newSalaryHeader {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin-bottom: 20px;
}
.back-button {
  padding: 5px 10px;
  /* background-color: #deecdd;  */
  color: gray;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.add_salary_header {
  margin-left: 27%;
}

.salary-component-list-container {
  width: 100%;
  height: 74vh;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
   overflow-y:auto; 
  display: flex;
  flex-direction: column;
}

.salary-component-table-wrapper {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: auto;
}

.salary-component-table {
  width: 100%;
  border-collapse: collapse;
  overflow-y: scroll;
  font-family: "Segoe UI", sans-serif;
  font-size: 14px;
}

.salary-component-table thead th {
  background-color: #e8f5e9;
  color: #2e7d32;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 2;
}

.salary-component-table th,
.salary-component-table td {
  border: 1px solid #ddd;
  padding: 12px 8px;
  text-align: center;
  vertical-align: middle;
  /* display: flex; */
  justify-content: center;
  gap: 11px;
  margin-top: 0px;
}

.salary-component-table tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

.salary-component-table tbody tr:hover {
  background-color: #d5d8db;
  cursor: pointer;
}

.salary-component-table .action-buttons button {
  margin: 0 3px;
  padding: 5px 10px;
  font-size: 12px;
  border: none;
  color: rgb(12, 12, 12);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.salary-component-table .action-buttons button:hover {
  background-color: #adcbe8;
}
/* form */

.check1 {
  display: flex;
  margin-top: 12px;
  height: 30px;
}
.check1 input {
  height: 15px;
  width: 10%;
  margin-top: 5px;
}
.check1:hover {
  background-color: rgba(222, 236, 221, 0.9647);
}

.check1 label {
  width: 200px;
  font-size: 0.9rem;
  margin-top: 5px;
}
.form-section-title {
  font-weight: 600;
}

.form-row1 {
  display: flex;
  gap: 68px;
}
.form-row1 input[type="date"] {
  height: 34px;
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Karla", sans-serif;
}
.form-row1 input[type="text"] {
  height: 34px;
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Karla", sans-serif;
}
.form-row3 {
  /* border: 1px solid black; */
  display: flex;
  gap: 68px;
  width: 100%;
  margin-top: 10px;
}
.form-row3 select {
  width: 135px;
  height: 38px;
}

.form-actions {
  /* border: 1px solid black; */
  height: 37px;
  text-align: center;
  margin-top: 10px;
}
.form-actions button {
  /* border: 1px solid black; */
  color: white;
  background-color: rgb(132, 199, 174);
  border-radius: 6px;
  padding: 10px;
}

.form-row2 select {
  width: 135px;
  height: 38px;
}
.disablefeild{
  color: #b3b9be;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .add-button-container {
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 20px; */
  }
  .list_salary_header {
    margin-bottom: 6px;
  }
  .salary-component-table-wrapper {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: auto;
  }
  .salary-component-table {
    width: 100%;
    border-collapse: collapse;
    font-family: "Segoe UI", sans-serif;
    font-size: 14px;
  }
  .salary-component-table thead th {
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .salary-component-table td {
    padding: 12px 8px;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    gap: 11px;
    margin-top: 0px;
    font-weight: 600;
    font-size: 11px;
  }
}

@media screen and (min-width: 1440px) {
  .salary-component-list-container {
    width: 100%;
    height: 74vh;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .add-button-container {
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 20px; */
  }
  .list_salary_header {
    margin-bottom: 20px;
  }
  .salary-component-table-wrapper {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: auto;
  }
  .salary-component-table {
    width: 100%;
    border-collapse: collapse;
    font-family: "Segoe UI", sans-serif;
    font-size: 14px;
  }
  .salary-component-table thead th {
    background-color: #e8f5e9;
    color: #2e7d32;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .salary-component-table td {
    border: 1px solid #ddd;
    padding: 12px 8px;
    text-align: center;
    vertical-align: middle;
    /* display: flex
; */
    justify-content: center;
    gap: 11px;
    margin-top: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/SalaryComponent.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;AACA,YAAY;AACZ;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;GACZ,eAAe;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA,SAAS;;AAET;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,mCAAmC;IACnC,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,mCAAmC;IACnC,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB;GACD;IACC,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".salary-form-container {\n  max-width: 1000px;\n  margin: auto;\n  background: #fff;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  font-family: sans-serif;\n}\n.salary-component-list-container {\n  width: 100%;\n  height: 77vh;\n  /* overflow: scroll; */\n  border: 1px solid black;\n  padding: 10px;\n}\n.salary-component-list-container::-webkit-scrollbar {\n  display: none;\n}\n\n.salary_form_section {\n  border: 1px solid rgb(208, 204, 204);\n  border-radius: 8px;\n  height: 59vh;\n  overflow: scroll;\n  padding: 10px;\n}\n.salary-form {\n  display: flex;\n  gap: 40px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n}\n\n.form-column {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\nlabel {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n}\n\nlabel span {\n  color: red;\n}\n\ninput[type=\"text\"],\ninput[type=\"date\"],\nselect {\n  padding: 8px;\n  margin-top: 4px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.checkbox-row,\n.radio-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-footer {\n  margin-top: 30px;\n  text-align: right;\n}\n\n.close-button {\n  padding: 10px 20px;\n  background-color: #28a745; /* green */\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.list_salary_header {\n  margin-bottom: 20px;\n  margin-left: 10px;\n}\n.add-button-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.add-button-container h3{\nmargin: auto;\n}\n\n.newSalaryHeader {\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: center;\n  margin-bottom: 20px;\n}\n.back-button {\n  padding: 5px 10px;\n  /* background-color: #deecdd;  */\n  color: gray;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.add_salary_header {\n  margin-left: 27%;\n}\n\n.salary-component-list-container {\n  width: 100%;\n  height: 74vh;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n   overflow-y:auto; \n  display: flex;\n  flex-direction: column;\n}\n\n.salary-component-table-wrapper {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.salary-component-table {\n  width: 100%;\n  border-collapse: collapse;\n  overflow-y: scroll;\n  font-family: \"Segoe UI\", sans-serif;\n  font-size: 14px;\n}\n\n.salary-component-table thead th {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.salary-component-table th,\n.salary-component-table td {\n  border: 1px solid #ddd;\n  padding: 12px 8px;\n  text-align: center;\n  vertical-align: middle;\n  /* display: flex; */\n  justify-content: center;\n  gap: 11px;\n  margin-top: 0px;\n}\n\n.salary-component-table tbody tr:nth-child(odd) {\n  background-color: #f9f9f9;\n}\n\n.salary-component-table tbody tr:hover {\n  background-color: #d5d8db;\n  cursor: pointer;\n}\n\n.salary-component-table .action-buttons button {\n  margin: 0 3px;\n  padding: 5px 10px;\n  font-size: 12px;\n  border: none;\n  color: rgb(12, 12, 12);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.salary-component-table .action-buttons button:hover {\n  background-color: #adcbe8;\n}\n/* form */\n\n.check1 {\n  display: flex;\n  margin-top: 12px;\n  height: 30px;\n}\n.check1 input {\n  height: 15px;\n  width: 10%;\n  margin-top: 5px;\n}\n.check1:hover {\n  background-color: rgba(222, 236, 221, 0.9647);\n}\n\n.check1 label {\n  width: 200px;\n  font-size: 0.9rem;\n  margin-top: 5px;\n}\n.form-section-title {\n  font-weight: 600;\n}\n\n.form-row1 {\n  display: flex;\n  gap: 68px;\n}\n.form-row1 input[type=\"date\"] {\n  height: 34px;\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: \"Karla\", sans-serif;\n}\n.form-row1 input[type=\"text\"] {\n  height: 34px;\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: \"Karla\", sans-serif;\n}\n.form-row3 {\n  /* border: 1px solid black; */\n  display: flex;\n  gap: 68px;\n  width: 100%;\n  margin-top: 10px;\n}\n.form-row3 select {\n  width: 135px;\n  height: 38px;\n}\n\n.form-actions {\n  /* border: 1px solid black; */\n  height: 37px;\n  text-align: center;\n  margin-top: 10px;\n}\n.form-actions button {\n  /* border: 1px solid black; */\n  color: white;\n  background-color: rgb(132, 199, 174);\n  border-radius: 6px;\n  padding: 10px;\n}\n\n.form-row2 select {\n  width: 135px;\n  height: 38px;\n}\n.disablefeild{\n  color: #b3b9be;\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .add-button-container {\n    display: flex;\n    justify-content: space-between;\n    /* margin-bottom: 20px; */\n  }\n  .list_salary_header {\n    margin-bottom: 6px;\n  }\n  .salary-component-table-wrapper {\n    flex: 1 1;\n    overflow-y: auto;\n    overflow-x: auto;\n  }\n  .salary-component-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: \"Segoe UI\", sans-serif;\n    font-size: 14px;\n  }\n  .salary-component-table thead th {\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n  }\n  .salary-component-table td {\n    padding: 12px 8px;\n    text-align: center;\n    vertical-align: middle;\n    justify-content: center;\n    gap: 11px;\n    margin-top: 0px;\n    font-weight: 600;\n    font-size: 11px;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .salary-component-list-container {\n    width: 100%;\n    height: 74vh;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 10px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n  .add-button-container {\n    display: flex;\n    justify-content: space-between;\n    /* margin-bottom: 20px; */\n  }\n  .list_salary_header {\n    margin-bottom: 20px;\n  }\n  .salary-component-table-wrapper {\n    flex: 1 1;\n    overflow-y: auto;\n    overflow-x: auto;\n  }\n  .salary-component-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: \"Segoe UI\", sans-serif;\n    font-size: 14px;\n  }\n  .salary-component-table thead th {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n  }\n  .salary-component-table td {\n    border: 1px solid #ddd;\n    padding: 12px 8px;\n    text-align: center;\n    vertical-align: middle;\n    /* display: flex\n; */\n    justify-content: center;\n    gap: 11px;\n    margin-top: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
